<template>
  <div style="height: 80vh; min-height: 500px; max-height: 800px;" class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between">
      <h3>Nueva guía</h3>
      <base-button @click="$emit('openEditAddress')" size="sm" outline type="primary">
        Editar dirección
      </base-button>
    </div>
    <hr class="w-100 my-2" />
    <div class="d-flex" style="flex:1; min-height: 0;">
      <div style="width: 300px; flex-shrink: 0; overflow: hidden auto; padding: 0 3px;">
        <div class="row">
          <div class="col-12 mb-2">
            <div class="text-xs font-weight-bold mb-1">Paquetería *</div>
            <div
              class="mb-2"
              style="	display: grid;grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px;"
            >
              <div
                v-for="carrier in carriers"
                :key="carrier.name"
                class="carrier"
                :style="{
                  opacity:
                    (selCarrier && carrier.name === selCarrier.name) ||
                    !selCarrier ? 1 : 0.2,
                  backgroundColor: carrier.color,
                }"
                @click="onSelectCarrier(carrier)"
                :disabled="selCarrier && !services"
              >
                <img
                  :src="require(`@/assets/carriers/${carrier.fileName}`)"
                  style="height:50px; width:90px; object-fit: contain;"
                />
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="text-xs font-weight-bold">Servicio *</div>
            <multiselect
              v-model="selService"
              :options="services || []"
              v-append-to-body
              class="mb-2 small-multiselect"
              placeholder="Servicio"
              :custom-label="serviceLabel"
              :show-labels="false"
              :allow-empty="false"
              :loading="selCarrier && !services"
              :disabled="!selCarrier"
              @select="getLocations('service', $event)"
            >
            </multiselect>
          </div>
          <div class="col-12">
            <div class="text-xs font-weight-bold">Contacto *</div>
            <multiselect
              v-model="selContact"
              :options="contacts"
              v-append-to-body
              track-by="InternalCode"
              :custom-label="(c) => `${c.Name} - ${c.E_Mail}`"
              class="mb-2 small-multiselect"
              placeholder="Contacto"
              :show-labels="false"
              :allow-empty="false"
              @select="getLocations('contact', $event)"
            />
          </div>
          <div v-if="selService && selService.name === 'Ocurre' && selContact && packages.length" class="col-12">
            <div class="text-xs font-weight-bold">Ubicación *</div>
            <multiselect
              v-model="selLocation"
              :options="locations || []"
              v-append-to-body
              track-by="clave"
              class="mb-2 small-multiselect"
              placeholder="Ubicación"
              :loading="!locations"
              :show-labels="false"
              :allow-empty="false"
            >
              <template slot="singleLabel" slot-scope="props">
                <div class="text-xs">
                  <b class="font-bold">{{props.option.nombre}}</b>
                  <br>
                  <span class="font-normal">{{[props.option.calle, props.option.numero].filter(x => x).join(', ')}}</span>
                  <br>
                  <span class="font-normal">{{[props.option.codigoPostal, props.option.ciudad, props.option.estado].filter(x => x).join(', ')}}</span>
                </div>
              </template>
              <template slot="option" slot-scope="props">
                <div class="text-xs">
                  <b class="font-bold">{{props.option.nombre}}</b>
                  <br>
                  <span class="font-normal">{{[props.option.calle, props.option.numero].filter(x => x).join(', ')}}</span>
                  <br>
              <span class="font-normal">{{[props.option.codigoPostal, props.option.ciudad, props.option.estado].filter(x => x).join(', ')}}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div v-if="selCarrier && selCarrier.name === 'Paquetexpress'" class="col-12 align-self-center">
            <base-checkbox v-model="paqExpInsurance">
              <div class="text-xs font-weight-bold" style="margin-top: 3px;">
                Asegurar
              </div>
            </base-checkbox>
          </div>
          <div v-if="selCarrier && selCarrier.name === 'Paquetexpress' && paqExpInsurance" class="col-12 mt-2 ">
            <div class="text-xs font-weight-bold">Valor (MXP) *</div>
            <base-input
              v-model="paqExpInsuranceValue"
              type="number"
              placeholder="Valor aseg."
              inputClasses="input-group-alternative form-control-sm text-xs"
              class="mb-2"
              min="0"
              max="100000"
            />
          </div>

          <div v-if="warnings && warnings.length" class="col-12 d-flex flex-column mt-2" style="gap:8px;">
            <div
              v-for="(warning, index) in warnings"
              :key="index"
              class="d-flex align-items-center py-1 px-2 rounded" 
              style="background: #fefce8; color: #ca8a04; letter-spacing: 0.5px; font-size: 11px;">
              <i class="fa fa-exclamation-triangle mr-2"></i>
                {{warning}}
            </div>
          </div>

        </div>
      </div>
      <div class="mx-3" style="border-left: 1px solid rgba(0, 0, 0, 0.05);"></div>

      <div style="flex: 1; display: flex; flex-direction: column; min-height: 0;">
        <div class="row">
          <div class="col-12 d-flex justify-content-between align-items-center">
              <h4 v-if="editing === null" class="m-0">Paquetes</h4>
              <h4 v-else class="m-0">Editar paquete #{{editing + 1}}</h4>

            <div class="d-flex justify-content-end">
              <!-- Editing buttons -->
              <base-button
                v-if="editing !== null"
                @click="cancelEdit()"
                size="sm"
                type="muted"
              >
                Cancelar
              </base-button>
              <div
                v-if="editing !== null"
                v-b-popover.hover.focus.bottom.html="popoverPackage"
              >
                <base-button
                  @click="saveChangesPkg()"
                  :disabled="!packageValid.valid"
                  size="sm"
                  outline
                  type="primary"
                  icon="fa fa-check"
                >
                  Guardar cambios
                </base-button>
              </div>
              <!-- Add buttons -->
              <base-button
                v-if="showPackageForm && editing === null"
                @click="showPackageForm = false"
                size="sm"
                type="muted"
              >
                Cancelar
              </base-button>
              <div 
                v-if="showPackageForm && editing === null" 
                v-b-popover.hover.focus.bottom.html="popoverPackage"
              >
                <base-button
                  @click="addPackage()"
                  :disabled="!packageValid.valid"
                  size="sm"
                  outline
                  type="primary"
                  icon="fa fa-check"
                >
                  Agregar paquete
                </base-button>
              </div>
              <!-- Show buttons -->
              <base-button
                v-if="!showPackageForm && editing === null"
                @click="showPackageForm = true"
                size="sm"
                outline
                type="primary"
                icon="fa fa-plus"
                :disabled="tarima"
              >
                Nuevo paquete
              </base-button>
            </div>
          </div>
          <hr class="my-2 w-100" />
          <div v-if="selCarrier && selCarrier.name === 'Paquetexpress'" class="col-12">
            <base-checkbox v-model="tarima" @input="onChangeTarima" 
            :disabled="loadingPackages || packages.length === 0 || editing !== null">
              <div class="text-xs font-weight-bold mb-2" style="margin-top: 3px;">
                Convertir paquetes a tarima
              </div>
            </base-checkbox>
          </div>
          <div v-if="showPackageForm" class="col-12">
            <div class="row">
              <div class="col-3">
                <div class="text-xs font-weight-bold">Descripción *</div>
                <base-input
                  v-model="pkgForm.content"
                  type="text"
                  placeholder="Descripción"
                  inputClasses="input-group-alternative form-control-sm text-xs"
                  class="mb-2"
                  minlength="3"
                  maxlength="28"
                />
              </div>
              <div v-if="selCarrier && selCarrier.name !== 'Paquetexpress'" class="col-3">
                <div class="text-xs font-weight-bold">Tipo *</div>
                <multiselect
                  v-model="pkgForm.selType"
                  :options="packTypes"
                  class="mb-2 small-multiselect"
                  placeholder="Tipo"
                  label="name"
                  track-by="id"
                  :show-labels="false"
                  :allow-empty="false"
                />
              </div>
              <div v-if="selCarrier && selCarrier.name !== 'Paquetexpress'" class="col-3 align-self-center">
                <base-checkbox v-model="pkgForm.insurance">
                  <div class="text-xs font-weight-bold" style="margin-top: 3px;">
                    Asegurar
                  </div>
                </base-checkbox>
              </div>
              <div v-if="selCarrier && selCarrier.name !== 'Paquetexpress'" class="col-3">
                <div v-if="pkgForm.insurance">
                  <div class="text-xs font-weight-bold">Valor (MXP) *</div>
                  <base-input
                    v-model="pkgForm.declaredValue"
                    type="number"
                    placeholder="Valor aseg."
                    inputClasses="input-group-alternative form-control-sm text-xs"
                    class="mb-2"
                    min="0"
                    max="100000"
                  />
                </div>
                <div v-else></div>
              </div>
              <div class="col-3">
                <div class="text-xs font-weight-bold">Peso (kg) *</div>
                <base-input
                  v-model="pkgForm.weight"
                  type="number"
                  placeholder="Peso"
                  inputClasses="input-group-alternative form-control-sm text-xs"
                  class="mb-2"
                  min="1"
                  max="1000"
                />
              </div>
              <div class="col-3">
                <div class="text-xs font-weight-bold">Largo (cm) *</div>
                <base-input
                  v-model="pkgForm.length"
                  type="number"
                  placeholder="Largo"
                  inputClasses="input-group-alternative form-control-sm text-xs"
                  class="mb-2"
                  min="1"
                  max="300"
                />
              </div>
              <div class="col-3">
                <div class="text-xs font-weight-bold">Ancho (cm) *</div>
                <base-input
                  v-model="pkgForm.width"
                  type="number"
                  placeholder="Ancho"
                  inputClasses="input-group-alternative form-control-sm text-xs"
                  class="mb-2"
                  min="1"
                  max="300"
                />
              </div>
              <div class="col-3">
                <div class="text-xs font-weight-bold">Alto (cm) *</div>
                <base-input
                  v-model="pkgForm.height"
                  type="number"
                  placeholder="Alto"
                  inputClasses="input-group-alternative form-control-sm text-xs"
                  class="mb-2"
                  min="1"
                  max="300"
                />
              </div>

            </div>
            <hr class="my-2 w-100" />
          </div>
        </div>
        <div
          v-if="packages.length > 0"
          style="flex:1; overflow: hidden auto; margin-right:-24px; margin-left: -16px; padding-right: 24px; padding-left:16px;"
        >
          <div 
            v-for="(pkg, index) in packages" 
            :key="index" 
            class="pkg-card" 
            :style="{
              opacity: editing !== null && editing !== index ? 0.3 : 1,
            }"
          >
          
            <i 
              class="text-light fa-lg" 
              :class="pkg.selType.icon" 
              style="margin: 0 12px;"
            />

            <div style="flex:1;">
              <div class="text-sm mb-1 d-flex align-items-center">
                <b>{{ pkg.content }}</b>
                <badge
                  v-if="pkg.insurance && selCarrier && selCarrier.name !== 'Paquetexpress'"
                  type="success"
                  class="ml-2"
                  style="text-transform: none; font-size: 11px;"
                >
                  Asegurado {{ currencyFormat(pkg.declaredValue) }}
                </badge>
              </div>
              <div class="text-xs">
                <badge
                  v-if="selCarrier && selCarrier.name !== 'Paquetexpress'" 
                  type="light"
                  class="mr-2"
                  style="text-transform: none; font-size: 11px;"
                >{{ pkg.selType.name }}
                </badge>
                <span class="mr-1">
                  <b>Peso:</b> {{ numberFormat(pkg.weight) }} kg
                </span>
                <span class="mr-1">
                  <b>Largo: </b>{{ numberFormat(pkg.length) }} cm
                </span>
                <span class="mr-1">
                  <b>Ancho: </b>{{ numberFormat(pkg.width) }} cm
                </span>
                <span>
                  <b>Alto: </b>{{ numberFormat(pkg.height) }} cm
                </span>
              </div>
            </div>
            <div>
              <i v-if="editing !== null && editing === index" class="fa fa-pen mx-2 text-light" ></i>
              <base-button 
                v-if="editing !== index"
                @click.prevent="editPackage(pkg, index)"
                v-tooltip.top="{ value: 'Editar' }"
                icon="fa fa-pen" 
                type="primary" 
                size="sm"
                outline 
                rounded 
                iconOnly 
              />
              <base-button
                v-if="editing === null"
                @click="removePackage(index)"
                v-tooltip.top="{ value: 'Quitar' }"
                icon="fa fa-trash"
                type="danger"
                size="sm"
                outline
                rounded
                iconOnly
              />
            </div>
          </div>
        </div>
        <div
          v-else
          style="flex: 1"
          class="d-flex justify-content-center align-items-center"
        >
          <base-loader v-if="loadingPackages"></base-loader>
          <div
            v-else-if="!quoting && ((rates && rates.length === 0) || !rates)"
            class="d-flex flex-column align-items-center"
          >
            <EmptySection />
          </div>
        </div>
      </div>
    </div>
    <hr class="w-100 my-2" />
    <div class="d-flex justify-content-between align-items-center">
      <div v-b-popover.hover.focus.bottom.html="popoverQuote">
        <base-button
          @click="quote()"
          :disabled="!quoteValid.valid || quoting"
          size="sm"
          outline
          type="primary"
          nativeType="submit"
          icon="fa fa-calculator"
        >
          {{ !quoting ? "Cotizar total" : "Cotizando..." }}
        </base-button>
      </div>
      <div class="d-flex align-items-center">
        <div
          class="d-flex align-items-center py-1 px-2 rounded ml-2" 
          style="background: #e6fbff; color: #01a2c0; letter-spacing: 0.5px; font-size: 11px;">
          <i class="fa fa-info-circle mr-2"></i>
            El monto total es solo una estimación
        </div>
        <div class="text-sm ml-2" :class="quoting ? 'opacity-3' : ''">
          <b>Total: </b>
          <b>{{ currencyFormat(rateTotal || 0) }}</b>
        </div>
      </div>

    </div>
    <hr class="w-100 my-2" />
    <div class="d-flex justify-content-end" >
      <base-button
        type="secondary"
        @click="$emit('close')"
      >
        Cancelar
      </base-button>
      <div v-if="currentTracking" v-b-popover.hover.focus.bottom.html="popoverTracking">
        <base-button
          @click="saveTracking(currentTrackingIndex)"
          :disabled="!trackingValid.valid"
          type="primary"
          icon="fa fa-check"
        >
          Guardar cambios
        </base-button>
      </div>
      <div v-else v-b-popover.hover.focus.bottom.html="popoverTracking">
        <base-button
          @click="saveTracking()"
          :disabled="!trackingValid.valid"
          type="primary"
          icon="fa fa-check"
        >
          Agregar guía
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "primevue/tooltip";
import Vue from "vue";
Vue.directive("tooltip", Tooltip);
import axios from "axios";
import carriers from "@/data/carriers.json";
import BaseLoader from "@/components/BaseLoader.vue";
import EmptySection from "@/components/EmptySection.vue";
import Formats from "@/mixins/Formats";
import { getAuth } from "firebase/auth";
import Multiselect from "vue-multiselect";
import states from "@/data/states.json";
import appendToBody from '@/directives/appendToBody';

export default {
  name: "NewTracking",
  directives: {
    appendToBody,
  },
  mixins: [Formats],
  components: {
    BaseLoader,
    EmptySection,
    Multiselect,
  },
  props: {
    docType: String,
    invBaseEntry: Number,
    del: Object,
    customer: Object,
    warehouse: Object, 
    currentTracking: Object,
    currentTrackingIndex: Number,
  },
  data() {
    return {
      delivery: null,
      carriers: carriers.filter(carrier => carrier.id === "PAQUETEXPRESS"),
      rates: null,
      quoting: false,
      selContact: null,
      selCarrier: null,
      services: null,
      selService: null,
      selLocation: null,
      locations: null,
      paqExpInsurance: false,
      paqExpInsuranceValue: 0,
      rateTotal: null,
      packages: [],
      loadingPackages: false,
      showPackageForm: false,
      editing: null,
      useAddress: null,
      tarima: false,
      pkgForm: {
        insurance: true,
        declaredValue: 0,
      },
      warnings: null,
      packTypes: [
        { id: "envelope", name: "Sobre", icon: "fa fa-envelope" },
        { id: "box", name: "Caja", icon: "fa fa-box" },
        { id: "pallet", name: "Tarima", icon: "fa fa-pallet" },
      ],
      states: states.concat({
        code: "DF",
        name: "Distrito Federal",
        enviaCode: "DF",
      }),
    };
  },
  created() {
    this.HANA_URL = process.env.VUE_APP_HANA_URL;
    this.DATABASE = process.env.VUE_APP_DATABASE;
    const { email, displayName } = getAuth().currentUser;
    this.user = { email, displayName };
    this.resetPkgForm();
    this.loadingPackages = true;

    if(this.docType === "delivery"){
      this.delivery = this.del;

      if(this.currentTracking && this.currentTrackingIndex !== undefined){
        this.loadEdit();
      } else {
        this.getPreloaded(this.delivery.DocNum);
      }
    } 
    else if(this.docType === "invoice"){
      const json = {
        query: `--sql
          SELECT 
            "DocNum"
          FROM ${this.DATABASE}."ODLN"
          WHERE "DocEntry" = ${this.invBaseEntry}
        `
      };
      axios.post(`${this.HANA_URL}/api/hana/freedom`, json)
      .then((res) => {
        if(res.data.length && res.data[0].DocNum){
          axios.get(`/api/deliveries/getDelivery?DocNum=${res.data[0].DocNum}`)
            .then(res => {
              this.delivery = res.data.value[0];
              if(this.currentTracking && this.currentTrackingIndex !== undefined){
                this.loadEdit();
              } else {
                this.getPreloaded(this.delivery.DocNum);
              }
            })
            .catch((e) => { 
              console.error("Error getting preloaded packages", e);
            })
        } else {
          this.$swal("Error", "No se pudo obtener el número de entrega", "error");
          this.$emit("close");
        }
      })
      .catch((e) => {
        console.error("Error getting preloaded packages", e);
      })
    }
  },
  methods: {
    async onChangeTarima(tarima){
      if(tarima){
        this.packages = [{
          content: this.packages[0] ? this.packages[0].content : null,
          selType: this.packTypes.find(t => t.id === 'pallet'),
          weight: parseInt(this.packages.reduce((sum, p) => sum + (parseFloat(p.weight) || 0), 0) || 0),
          length: null,
          width: null,
          height: null,
          insurance: true,
          declaredValue: 0,
        }]
        this.paqExpInsurance = true;
        this.paqExpInsuranceValue = 1000
        this.editPackage(this.packages[0], 0)

      } else {
        this.loadingPackages = true;
        this.packages = [];
        await this.getPreloaded(this.delivery.DocNum);
      }
    },
    async getLocations(type, value){
      try {
        if(type === 'service'){
          this.selService = value;
        } else if(type === 'contact'){
          this.selContact = value;
        }
        if(!this.selService || !this.selContact || !this.packages.length){
          return;
        }
        if(this.selService.name === "Ocurre"){
            await this.checkAddresses();
          let to;
          if(this.useAddress === "customer"){
            const customerAddress = this.customer.BPAddresses
            .find(a => a.AddressName === this.delivery.ShipToCode && a.AddressType === "bo_ShipTo");
            const shipState = this.states.find(s => s.code === customerAddress.State);
            to = {
              country: customerAddress.Country,
              state:shipState ? shipState.name : null,
              city:customerAddress.City,
              district:customerAddress.Block,
              postalCode:customerAddress.ZipCode,
              street:customerAddress.Street,
              number:customerAddress.StreetNo,
              phone:this.customer.Phone1,
              company:this.customer.CardName,
              email: this.selContact.E_Mail
            };
          } else {
            const shipState = this.states.find(s => s.code === this.delivery.AddressExtension.ShipToState);
            to = {
              country: this.delivery.AddressExtension.ShipToCountry,
              state:shipState ? shipState.name : null,
              city:this.delivery.AddressExtension.ShipToCity,
              district:this.delivery.AddressExtension.ShipToBlock,
              postalCode:this.delivery.AddressExtension.ShipToZipCode,
              street:this.delivery.AddressExtension.ShipToStreet,
              number:this.delivery.AddressExtension.ShipToStreetNo,
              phone:this.customer.Phone1,
              company:this.customer.CardName,
              email: this.selContact.E_Mail
            };
          }

          const json = {
            to: to,
            packages: this.packages.map((p) => {
              const ocurreType = p.selType && p.selType.id === 'pallet' ? 'TARIMA' : 'PACKETS';
              return {
                type: ocurreType,
                satID: "01010101",
                dimensions: {
                  length: parseFloat(p.length),
                  width: parseFloat(p.width),
                  height: parseFloat(p.height)
                },
                weight: parseFloat(p.weight),
                content: p.content,
              };
            }),
          }
          const res = await axios.post(`/api/paquetexpress/ocurre_locations`, json);

          if(!Array.isArray(res.data)){
            console.error("Error", res);
            throw new Error("Locations not found");
          }
          this.locations = res.data;
          if(!this.locations.find(l => l.clave === (this.selLocation ? this.selLocation.clave : null))){
            this.selLocation = null;
          }
        }
      } catch (e) {
        console.error(e);
        this.locations = [];
      }
    },
    loadEdit(){
      this.packages = this.currentTracking.packages.map((p) => {
        let type;
        if(p.type === 'TARIMA') {
          type = 'pallet';
        } else if(p.type === 'PACKETS'){
          type = 'box';
        } else {
          type = p.type;
        }
        return {
          content: p.content,
          selType: this.packTypes.find(t => t.id === type),
          weight: p.weight,
          length: p.dimensions.length,
          width: p.dimensions.width,
          height: p.dimensions.height,
          insurance: p.insurance === 0 ? false : true,
          declaredValue: p.declaredValue,
        }
      });
      console.log("Editing tracking", this.currentTracking);



      if(this.currentTracking.origin){ // Envia
        this.selContact = this.contacts.find(c => c.E_Mail === this.currentTracking.destination.email);
        const carrier = this.carriers.find(c => c.id === this.currentTracking.shipment.carrier);
        this.onSelectCarrier(carrier)
        .then(() => {
          this.selService = this.services.find(s => s.name === this.currentTracking.shipment.service);
          this.selCarrier = carrier;
          this.quote()
        });
      } 
      else if(this.currentTracking.from) { // Paquetexpress
        this.paqExpInsurance = this.currentTracking.insuranceValue &&parseFloat(this.currentTracking.insuranceValue) > 0;
        this.paqExpInsuranceValue = this.currentTracking.insuranceValue ? parseFloat(this.currentTracking.insuranceValue) : 0;
        this.tarima = this.currentTracking.packages.every(p => p.type === 'TARIMA');
        this.selContact = this.contacts.find(c => c.E_Mail === this.currentTracking.to.email);
        const carrier = this.carriers.find(c => c.id === 'PAQUETEXPRESS');
        this.onSelectCarrier(carrier)
        .then(() => {
          this.selService = this.services.find(s => s.name === (this.currentTracking.isOcurre ? 'Ocurre' : 'STD'));
          this.selCarrier = carrier;
          if(this.selService && this.selService.name === "Ocurre" ){
            this.getLocations('edit')
            .then(() => {
              this.selLocation = this.locations.find(l => l.clave === (this.currentTracking.ocurreLocation ? this.currentTracking.ocurreLocation : null));
              this.quote()
            });
          }
        });
      }
    },
    
    saveChanges(){
      this.$emit("saveEdition", )
      this.$emit("close");
    },
    async getPreloaded(deliveryNum) {
      try {
        const carrier = this.carriers.find(c => c.id === 'PAQUETEXPRESS');
        this.onSelectCarrier(carrier);


        const res = await axios.get(`${this.HANA_URL}/api/shipments/get-packages-delivery/${deliveryNum}`);
          if(res.data.success){
            const packages = res.data.success.reduce((acc, line) => {
              return acc.concat(line.envia_api);
            }, []);
            this.warnings = res.data.warning.map((w) => w.message);
            this.packages = packages.map((p) => {
              return {
                content: p.content,
                selType: this.packTypes.find(t => t.id === p.type),
                weight: p.weight,
                length: p.dimensions.length,
                width: p.dimensions.width,
                height: p.dimensions.height,
                insurance: true,
                declaredValue: 0,
              }
            });
            this.paqExpInsurance = true;
            this.paqExpInsuranceValue = 1000
          } else {
            throw new Error("No packages found");
          }
          return;
      } catch (e) {
        console.error("Error getting preloaded packages", e);
        return;
      } finally {
        this.loadingPackages = false;
      }
    },
    resetPkgForm() {
      this.pkgForm = {
        content: null,
        selType: null,
        weight: null,
        length: null,
        width: null,
        height: null,
        insurance: true,
        declaredValue: 0,
      };
    },
    saveChangesPkg() {
      this.packages[this.editing] = this.pkgForm;
      this.showPackageForm = false;
      this.resetPkgForm();
      this.editing = null;
      if(this.selService && this.selService.name === "Ocurre" && this.selContact){
        this.getLocations('packages');
      }
    },
    async onSelectCarrier(carrier) {
      try {
        if (!this.selCarrier || this.selCarrier.name !== carrier.name) {
          if(carrier.name === "Paquetexpress"){
            this.packages.forEach(pkg => {
              if(!this.currentTracking){
                pkg.selType = this.packTypes.find(t => t.id === (this.tarima ? "pallet" : "box"));
              }
            });
          }
          this.selCarrier = carrier;

          if(carrier.name === "Paquetexpress"){
            this.services = [
              {
                carrier_name: "PAQUETEXPRESS",
                name: "STD",
                description: "Estándar",
                delivery_estimate: "",
              },
              {
                carrier_name: "PAQUETEXPRESS",
                name: "Ocurre",
                description: "Ocurre",
                delivery_estimate: "",
              }
            ];
            return [];
          }

          this.services = null;
          this.selService = null;
  
          const {data} = await axios.get(`/api/envia/services/by/courier/${carrier.urlId}`);
  
          if (Array.isArray(data)) {
            this.services = data;
            return data

          } else {
            console.error("Error", data);
            this.services = [];
            return [];
          }
        } else {
          return [];
        }
      } catch (error) {
        console.error("Error fetching services", error);
        this.services = [];
        return [];
      }
    },
    addPackage() {
      if(this.selCarrier && this.selCarrier.name === "Paquetexpress" ){
        if(this.tarima){
          this.pkgForm.selType = this.packTypes.find(t => t.id === "pallet");
        } else {
          this.pkgForm.selType = this.packTypes.find(t => t.id === "box");
        }
      }
      this.packages.push(this.pkgForm);
      this.resetPkgForm();
      this.showPackageForm = false;
      if(this.selService && this.selService.name === "Ocurre"){
        this.getLocations('packages');
      }
    },
    editPackage(pkg, index) {
      this.pkgForm = {
        content: pkg.content,
        selType: pkg.selType,
        weight: pkg.weight,
        length: pkg.length,
        width: pkg.width,
        height: pkg.height,
        insurance: pkg.insurance,
        declaredValue: pkg.declaredValue,
      };
      this.showPackageForm = true;
      this.editing = index;
    },
    cancelEdit() {
      this.editing = null;
      this.resetPkgForm();
      this.showPackageForm = false;
    },
    removePackage(index) {
      this.packages.splice(index, 1);
      if(this.selService && this.selService.name === "Ocurre" && this.selContact){
        this.getLocations('packages');
      }
    },
    quote() {
      this.quoting = true;
      if(this.selCarrier.name === "Paquetexpress"){
        this.quotePaquetexpress();
      } else {
        this.quoteEnvia();
      }
    },
    quoteEnvia(){
      const whsState = this.states.find(s => s.code === this.warehouse.State);
      const shipState = this.states.find(s => s.code === this.delivery.AddressExtension.ShipToState);
      const json = {
        origin: {
          name: "CANPLAST MÉXICO",
          company: "CANPLAST MÉXICO",
          email: this.user.email,
          phone: "6144819488",
          street: this.warehouse.Street,
          number: this.warehouse.StreetNo,
          district: this.warehouse.Block,
          city: this.warehouse.City,
          state: whsState ? whsState.enviaCode : null,
          country: this.warehouse.Country,
          postalCode: this.warehouse.ZipCode,
          reference: "",
        },
        destination: {
          name: this.customer.CardName,
          company: this.customer.CardName,
          email: this.selContact.E_Mail,
          phone: this.customer.Phone1,
          street: this.delivery.AddressExtension.ShipToStreet,
          number: this.delivery.AddressExtension.ShipToStreetNo,
          district: this.delivery.AddressExtension.ShipToBlock,
          city: this.delivery.AddressExtension.ShipToCity,
          state: shipState ? shipState.enviaCode : null,
          country: this.delivery.AddressExtension.ShipToCountry,
          postalCode: this.delivery.AddressExtension.ShipToZipCode,
          reference: "",
        },
        packages: this.packages.map((p) => {
          return {
            content: p.content,
            amount: 1,
            type: p.selType.id,
            dimensions: {
              length: parseFloat(p.length),
              width: parseFloat(p.width),
              height: parseFloat(p.height),
            },
            weight: parseFloat(p.weight),
            insurance: p.insurance ? 1 : 0,
            declaredValue: p.insurance ? p.declaredValue : 0,
            weightUnit: "KG",
            lengthUnit: "CM",
          };
        }),
        shipment: {
          carrier: this.selService.carrier_name,
          service: this.selService.name,
          type: 1,
        },
        settings: {
          currency: "MXN",
        },
      };
  
      axios
        .post(`/api/envia/quote`, json)
        .then(({data}) => {
          if (data.meta && data.meta === "rate") {
            this.rateTotal = data.data[0].totalPrice;
          } else {
            console.error("Error", data);
            if (data.error) {
              this.$swal(data.error.description, data.error.message, "error");
            } else if(data.code && data.code === 400) {
              this.$swal(data.message, data.description, "error");
            } else {
              this.$swal("Error", `No se pudo obtener la cotización`, "error");
            }
          }
        })
        .catch((e) => {
          console.error("Error", e);
          this.$swal("Error", `No se pudo obtener la cotización`, "error");
        })
        .finally(() => {
          this.quoting = false;
        });
    },

    async quotePaquetexpress() {
      if(!this.useAddress){
        await this.checkAddresses();
      } 
      let zipCodeDest, colonyDest;
      if(this.useAddress === "customer"){
        const customerAddress = this.customer.BPAddresses
          .find(a => a.AddressName === this.delivery.ShipToCode && a.AddressType === "bo_ShipTo");
        zipCodeDest = customerAddress.ZipCode;
        colonyDest = customerAddress.Block;
      } else if(this.useAddress === "delivery"){
        zipCodeDest = this.delivery.AddressExtension.ShipToZipCode;
        colonyDest = this.delivery.AddressExtension.ShipToBlock;
      } else {
        this.quoting = false;
        return; 
      }

      const json = {
        zipCodeOrig: this.warehouse.ZipCode,
        colonyOrig: this.warehouse.Block,
        zipCodeDest: zipCodeDest,
        colonyDest: colonyDest,
        insuranceValue: this.paqExpInsurance ? this.paqExpInsuranceValue : 0,
        shipments: this.packages.map((p) => {
          return {
            weight: parseFloat(p.weight),
            longShip: parseFloat(p.length),
            widthShip: parseFloat(p.width),
            highShip: parseFloat(p.height)
          };
        }),
      }

      axios
        .post(`/api/paquetexpress/quote`, json)
        .then(({data}) => {
          if(data.amount){
            this.rateTotal = data.amount.totalAmnt;
          } else {
            if(data.body && data.body.response && data.body.response.messages){
              this.$swal("Error", data.body.response.messages.map(m => m.description).join(". "), "error");
            } else {
              this.$swal("Error", `No se pudo obtener la cotización`, "error");
            }
            console.error("Error", data);
          }

        })
        .catch((e) => {
          console.error("Error", e);
          this.$swal("Error", `No se pudo obtener la cotización`, "error");
        })
        .finally(() => {
          this.quoting = false;
        });
    },

    async saveTracking(trkdIndex){
      let json;
      if(this.selCarrier.name === "Paquetexpress"){
        json = await this.trackingPaquetexpress(trkdIndex);
      } else {
        json = this.trackingEnvia(trkdIndex);
      } 

      if(trkdIndex || trkdIndex === 0){ //edit tracking at index position
        this.$emit("edit", json, trkdIndex);
      } else { // Add new tracking
        this.$emit("add", json)
      }
      this.$emit("close");
    },

    trackingEnvia() {
      const whsState = this.states.find((s) => s.code === this.warehouse.State);
      const shipState = this.states.find((s) => s.code === this.delivery.AddressExtension.ShipToState);

      return {
        origin: {
          name: "CANPLAST MÉXICO",
          company: "CANPLAST MÉXICO",
          email: this.user.email,
          phone: "6144819488",
          street: this.warehouse.Street,
          number: this.warehouse.StreetNo,
          district: this.warehouse.Block,
          city: this.warehouse.City,
          state: whsState ? whsState.enviaCode : null,
          country: this.warehouse.Country,
          postalCode: this.warehouse.ZipCode,
          reference: ``,
        },
        destination: {
          name: this.customer.CardName,
          company: this.customer.CardName,
          email: this.selContact.E_Mail,
          phone: this.customer.Phone1,
          street: this.delivery.AddressExtension.ShipToStreet,
          number: this.delivery.AddressExtension.ShipToStreetNo,
          district: this.delivery.AddressExtension.ShipToBlock,
          city: this.delivery.AddressExtension.ShipToCity,
          state: shipState ? shipState.enviaCode : null,
          country: this.delivery.AddressExtension.ShipToCountry,
          postalCode: this.delivery.AddressExtension.ShipToZipCode,
          reference: "",
        },
        packages: this.packages.map((p) => {
          return {
            content: p.content,
            amount: 1,
            type: p.selType.id,
            dimensions: {
              length: parseFloat(p.length),
              width: parseFloat(p.width),
              height: parseFloat(p.height),
            },
            weight: parseFloat(p.weight),
            insurance: p.insurance ? 1 : 0,
            declaredValue: p.insurance ? p.declaredValue : 0,
            weightUnit: "KG",
            lengthUnit: "CM",
          };
        }),
        shipment: {
          carrier: this.selService.carrier_name,
          service: this.selService.name,
          type: 1,
        },
        settings: {
          printFormat: "PDF",
          printSize: "STOCK_4X6",
          comments: null,
        },
      };
    },
    async checkAddresses() {
      if(this.useAddress){
        return this.useAddress;
      }
      // Check if customer and delivery address match
      const custAddress = this.customer.BPAddresses
        .find(a => a.AddressName === this.delivery.ShipToCode && a.AddressType === "bo_ShipTo");
      const { Street, StreetNo, Block, City, State, Country, ZipCode } = custAddress;
      const { ShipToStreet, ShipToStreetNo, ShipToBlock, ShipToCity, ShipToState, ShipToCountry, ShipToZipCode } = this.delivery.AddressExtension;

      let match = (
        Street === ShipToStreet &&
        StreetNo === ShipToStreetNo &&
        Block === ShipToBlock &&
        ZipCode === ShipToZipCode &&
        City === ShipToCity &&
        State === ShipToState &&
        Country === ShipToCountry
      );
      if(!match){
        const choice = await this.$swal({
          title: `Elegir dirección`,
          html: `
            <span>La dirección de la entrega no coincide con la dirección del cliente</span>
            <br>
            <br>
            <div style="display: flex; width: 100%; gap:12px;font-size:14px; text-align: start;">

              <div style="flex: 1;">
                <b>Cliente</b>
                <div>
                  <span>${Street}</span> <br>
                  <span>${StreetNo}</span> <br>
                  <span>${Block}</span> <br>
                  <span>${ZipCode}</span> <br>
                  <span>${City}</span> <br>
                  <span>${State}</span> <br>
                  <span>${Country}</span>
                </div>
              </div>
              <br>
              <div style="flex: 1;">
                <b>Entrega</b>
                <div>
                  <span>${ShipToStreet}</span> <br>
                  <span>${ShipToStreetNo}</span> <br>
                  <span>${ShipToBlock}</span> <br>
                  <span>${ShipToZipCode}</span> <br>
                  <span>${ShipToCity}</span> <br>
                  <span>${ShipToState}</span> <br>
                  <span>${ShipToCountry}</span>
                </div>
              </div>
              
            </div>
          `,
          confirmButtonText: "Usar dirección del cliente",
          cancelButtonText: "Mantener dirección de la entrega",
          showCancelButton: true,
        })
        if(choice.isConfirmed){
          this.useAddress = "customer";
        } else if(choice.isDismissed && choice.dismiss === 'cancel'){
          this.useAddress = "delivery";
        }
      } else {
        this.useAddress = "delivery";
      }
    },
    async trackingPaquetexpress() {
      let to;
      if(this.useAddress === "customer"){
        const customerAddress = this.customer.BPAddresses
          .find(a => a.AddressName === this.delivery.ShipToCode && a.AddressType === "bo_ShipTo");
        const shipState = this.states.find((s) => s.code === customerAddress.State);
        to = {
          country: customerAddress.Country,
          state: shipState ? shipState.name : null,
          city: customerAddress.City,
          district: customerAddress.Block,
          postalCode: customerAddress.ZipCode,
          street: customerAddress.Street,
          number: customerAddress.StreetNo,
          phone: this.customer.Phone1,
          company: this.customer.CardName,
          email: this.selContact.E_Mail,
        };
      } else if(this.useAddress === "delivery"){
        const shipState = this.states.find((s) => s.code === this.delivery.AddressExtension.ShipToState);
        to = {
          country: this.delivery.AddressExtension.ShipToCountry,
          state: shipState ? shipState.name : null,
          city: this.delivery.AddressExtension.ShipToCity,
          district: this.delivery.AddressExtension.ShipToBlock,
          postalCode: this.delivery.AddressExtension.ShipToZipCode,
          street: this.delivery.AddressExtension.ShipToStreet,
          number: this.delivery.AddressExtension.ShipToStreetNo,
          phone: this.customer.Phone1,
          company: this.customer.CardName,
          email: this.selContact.E_Mail,
        };
      } else {
        await this.checkAddresses();
        this.trackingPaquetexpress();
      }

      const whsState = this.states.find((s) => s.code === this.warehouse.State);

      return {
        from: {
          country: this.warehouse.Country,
          state: whsState ? whsState.name : null,
          city: this.warehouse.City,
          district: this.warehouse.Block,
          postalCode: this.warehouse.ZipCode,
          street: this.warehouse.Street,
          number: this.warehouse.StreetNo,
        },
        to: to,
        insuranceValue: this.paqExpInsurance ? this.paqExpInsuranceValue : 0,
        invoiceReference: null, // Llenar despues de crear la factura
        packages: this.packages.map((p) => {
          const ocurreType = p.selType && p.selType.id === 'pallet' ? 'TARIMA' : 'PACKETS';
          return {
            type: ocurreType,
            satID: "01010101",
            dimensions: {
              length: parseFloat(p.length),
              width: parseFloat(p.width),
              height: parseFloat(p.height)
            },
            weight: parseFloat(p.weight),
            content: p.content,
          };
        }),
        isOcurre: this.selService.name === "Ocurre",
        ocurreLocation: this.selService.name === "Ocurre" ? this.selLocation.clave : null,
      };
    },
    serviceLabel({description, delivery_estimate}){
      description = description
      .replace(/^Tres Guerras\s*/, "")
      .replace(/^Estafeta\s*/, "")
      .replace(/^99Min\s*/, "");
      return `${description ? `${description}` : ''}${delivery_estimate ? `: ${delivery_estimate}` : ''}`;
    }
  },
  computed: {
    contacts() {
      return this.customer.ContactEmployees.map(({ InternalCode, Name, E_Mail }) => {
        return {InternalCode, Name, E_Mail};
      });
    },
    packageValid() {
      const { 
        content, length, width, weight, height, insurance, declaredValue, selType,
      } = this.pkgForm;
      let complete;

      if(this.selCarrier && this.selCarrier.name === "Paquetexpress"){ // Paquetexpress
        complete = {
          "Descripción": content,
          "Peso": weight,
          "Largo": length,
          "Ancho": width,
          "Alto": height,
        };
      } else { // Envia
        complete = {
          "Descripción": content,
          "Tipo": selType,
          "Valor asegurado": (insurance ? declaredValue > 0 : true),
          "Peso": weight,
          "Largo": length,
          "Ancho": width,
          "Alto": height,
        };
      }

      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    quoteValid() {
      let packagesValid = 
        this.packages.length > 0 && 
        this.packages.every((p) => {
          return p.content && p.weight && p.length && p.width && p.height;
        });

      let insuranceValid;

      if(this.selCarrier && this.selCarrier.name === "Paquetexpress"){ // Paquetexpress
        packagesValid = 
          this.packages.length > 0 && 
          this.packages.every((p) => {
            return p.content && p.weight && p.length && p.width && p.height;
          });
        insuranceValid =(this.paqExpInsurance ? this.paqExpInsuranceValue > 0 : true)
      } else { // Envia
        packagesValid = 
          this.packages.length > 0 && 
          this.packages.every((p) => {
            return p.content && 
              p.selType && 
              (p.insurance ? p.declaredValue > 0 : true) && 
              p.weight && 
              p.length && 
              p.width && 
              p.height;
          });
        insuranceValid = true;
      }

      const complete = {
        "Paquetería": this.selCarrier,
        "Servicio": this.selService,
        "Contacto": this.selContact,
        "Paquetes": packagesValid,
        "Guardar cambios de paquete": this.editing === null,
        "Valor asegurado": insuranceValid,
        "Ubicación": this.selService && this.selService.name === 'Ocurre' ? this.selLocation : true,
      };
      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    trackingValid() {
      const complete = {
        "Total cotizado": this.rateTotal,
      };
      return {
        valid: Object.values(complete).every((x) => x) && this.quoteValid.valid,
        missing: Object.keys(complete).filter((x) => !complete[x]) 
          .concat(this.quoteValid.missing), 
      };
    },
    popoverPackage() {
      if (this.packageValid.missing.length > 0) {
        return {
          title: "<small><b>Verifica la siguiente información:</b></small>",
          content: `<ul><li>${this.packageValid.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
    popoverQuote() {
      if (this.quoteValid.missing.length > 0) {
        return {
          title: "<small><b>Verifica la siguiente información:</b></small>",
          content: `<ul><li>${this.quoteValid.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
    popoverTracking() {
      if (this.trackingValid.missing.length > 0) {
        return {
          title: "<small><b>Verifica la siguiente información:</b></small>",
          content: `<ul><li>${this.trackingValid.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pkg-card {
  display: flex;
  margin-bottom: 8px;
  border-radius: 0.4375rem;
  padding: 12px;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all .6s ease-in-out;
}

.carrier {
  cursor: pointer;
  position: relative;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4375rem;
  padding: 4px 10px;
}
.carrier:hover {
  scale: 1.02;
}
</style>

<style>
.p-tooltip {
  z-index: 9999 !important;
}
</style>
